import { useQuery } from '@apollo/client';
import dynamic from 'next/dynamic';
import React, { useEffect, useState } from 'react';
import { InView } from 'react-intersection-observer';
import { connect } from 'react-redux';
import {
  CurrentItemQuery,
  SelectedAgencyShortDataQuery
} from '../../../../../graphql/graphql';
import { getSelectedAgencyShortDataQuery } from '../../../../../api/queries';
import {
  SimilarAdsContainer,
  SimilarAdsContent
} from '../../SimilarAdsSection/styled';
import { SectionPlaceholder } from '../../../../Placeholders/SectionPlaceholder';
import { ItemCardPlaceholder } from '../../../../Placeholders/ItemCardPlaceholder';
import { SimilarSpaceSection } from './styled';
import { CompanyTargetTypeEnum } from '../../../../../graphql/types';
import { setError } from '../../../../../actions';

const SimilarAdsSection = dynamic(
  () => import('../../SimilarAdsSection').then(mod => mod.SimilarAdsSection),
  {
    ssr: false
  }
);

const AgencyFilter = dynamic(
  () => import('../../../../Agency/AgencyFilter').then(mod => mod.AgencyFilter),
  {
    ssr: false
  }
);

interface SimilarAdsBlockProps {
  data?: CurrentItemQuery['item'];
  item?: CurrentItemQuery['item'];
  isResidence: boolean;
  isAgency: boolean;
  setErrorUI: (value: boolean) => void;
}

const mapDispatchToProps = dispatch => {
  return {
    setErrorUI: (errorState: boolean) => dispatch(setError(errorState))
  };
};

const SimilarAdsBlockComponent: React.FC<SimilarAdsBlockProps> = ({
  item,
  data,
  isResidence,
  isAgency,
  setErrorUI
}) => {
  const [skipRequest, setSkipRequest] = useState(true);

  const {
    data: agencyData,
    loading: agencyDataLoading,
    error: agencyDataError
  } = useQuery<SelectedAgencyShortDataQuery>(getSelectedAgencyShortDataQuery, {
    variables: { id: data?.business?.id },
    skip:
      !data ||
      !data?.business?.id ||
      data?.company?.targetType !== CompanyTargetTypeEnum.Agency ||
      skipRequest,
    ssr: false
  });

  useEffect(() => {
    if (agencyDataError) setErrorUI(true);
  }, [agencyDataError]);

  return (
    <InView
      as="div"
      onChange={inView => {
        if (inView) {
          setSkipRequest(false);
        }
      }}
    >
      {item && isAgency ? (
        <SimilarAdsContainer>
          <SimilarAdsContent>
            <SimilarSpaceSection>
              {agencyDataLoading && !agencyData ? (
                <SectionPlaceholder>
                  {Array.from({ length: 4 }, (_, index) => (
                    <ItemCardPlaceholder key={index} isCardsLayout />
                  ))}
                </SectionPlaceholder>
              ) : (
                <AgencyFilter
                  categories={agencyData?.agency?.itemCategories}
                  allCategories={agencyData?.categories}
                  agencyId={agencyData?.agency?.id}
                  isCurrentItemPage
                />
              )}
            </SimilarSpaceSection>
          </SimilarAdsContent>
        </SimilarAdsContainer>
      ) : (
        <SimilarAdsSection
          isResidence={isResidence}
          categoryId={item?.category?.id || ''}
          leased={item?.leased}
          companyId={item?.company?.id}
          currentItemId={item?.id || ''}
          skipRequest={skipRequest}
          categoryPluralName={item?.category?.pluralName}
        />
      )}
    </InView>
  );
};

export const SimilarAdsBlock = connect(
  null,
  mapDispatchToProps
)(SimilarAdsBlockComponent);
